import type {
  RegisterRequest,
  RegisterResponse,
} from '@/widgets/auth/Register/models';

import { X_HOST_HEADER_KEY } from '@/shared/api';
import { baseClient } from '@/shared/api/baseClient';
import { env } from '@/shared/lib/env';

export const registerAsync = async (
  body: RegisterRequest,
  inCore?: boolean
) => {
  const response = await baseClient.post<RegisterResponse>(
    '/auth/signup',
    body,
    {
      headers: !inCore
        ? {
            [X_HOST_HEADER_KEY]: `${env.VITE_APP_TENANT}.${env.VITE_API_DOMAIN}`,
          }
        : {},
    }
  );
  return response.data;
};
